import { LoadingSpinner } from "@/components/loading/loading-spinner";
import { memo } from "react";

interface MealCreatingProgressProps {
  statues?: Record<string, string>;
}

const MealCreatingProgress = memo(function MealCreatingProgress({
  statues,
}: MealCreatingProgressProps) {
  console.log("statues", statues);
  return (
    <div className="flex flex-col items-center gap-12">
      <LoadingSpinner />

      <div className="flex flex-col items-center gap-4 text-center">
        <h2 className="font-bold">We're creating your plan!</h2>
        <p className="text-gray-600">Exciting times</p>
      </div>

      {/* {statues && (
        <div className="fixed bottom-8 left-0 right-0 max-w-[420px] mx-auto">
          {Object.entries(statues).map(([mealTime, status]) => (
            <div
              key={mealTime}
              className="w-[200px] flex justify-between items-center gap-2 mx-auto"
            >
              <h6 className="font-bold text-gray-500">{mealTime}: </h6>
              <p className="capitalize text-gray-500">{status}</p>
            </div>
          ))}
        </div>
      )} */}
    </div>
  );
});

export default MealCreatingProgress;
